import { Modal as ModalModule, Utils } from 'common';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;
const { Session, Util, BillingPlans } = Utils;
const { prettyPrintPlan } = BillingPlans;

const PlanChangedModal = ({ modalId, data }) => {
	const { newPlanName, newPlanCost } = data;
	const { BillingDayOfMonth, CurrentServiceFees } =
		Session.getInternalAccountInfo();
	const contactNumber = Util.getFraudNumber();

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'OK',
		dataqa: 'plan-change-ok-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="account-change-plan plan-changed-modal"
			header="Plan Changed"
			primaryButton={primaryButton}
		>
			<div className="body">
				<p>
					Your subscription plan has been changed to the{' '}
					<b>{prettyPrintPlan(newPlanName)}</b>. If you are upgrading your plan,
					we have made your new plan features available for you to use
					immediately, but we will not charge you the higher plan fees until
					your next billing cycle. If you are downgrading your plan, you will
					have access to your prior account features through the end of your
					current billing cycle:{' '}
					{Util.getBillingDate(BillingDayOfMonth, 'long')}.
				</p>
				<p>
					Stamps.com bills at the end of each month of service, and you will not
					be charged for the new plan fees until your next billing cycle.
					Therefore, your next service fee bill is expected to be $
					{CurrentServiceFees} plus applicable taxes, if any, on{' '}
					{Util.getBillingDate(BillingDayOfMonth, 'long')}. You will be charged
					the {prettyPrintPlan(newPlanName)} fee of ${newPlanCost} per month
					plus applicable taxes, if any, for each billing cycle after that.
				</p>
				<p>
					If you have any questions or need further assistance, please contact
					customer support toll-free at {contactNumber}, Monday - Friday, 6 a.m.
					- 6 p.m. Pacific Time.
				</p>
			</div>
		</Modal>
	);
};

export default PlanChangedModal;
